import { Form, Formik } from "formik";
import { InputControl, SubmitButton } from "formik-chakra-ui";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useChangePasswordMutation } from "../../store/api";
import {
  Flex,
  Box,
  Stack,
  Heading,
  Text,
  useColorModeValue,
  useToast
} from '@chakra-ui/react';
import { useState } from "react";

const ChangePassword = () => {
  const { token } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
  const [passwordMatch, setPasswordMatch] = useState("");



  const [changePassword, { data, isError, isLoading, error, isSuccess }] =
    useChangePasswordMutation();



  return (
    <Formik
      initialValues={{ newPassword: "", currentPassword: "", confirmNewPassword: "" }}
      validate={values => {
        let errors = {};
        if (values.newPassword.length && values.confirmNewPassword.length && values.newPassword !== values.confirmNewPassword) {
          errors = { ...errors, confirmNewPassword: "Password does not match. Please verify password again" };
          setPasswordMatch("Password does not match");
          return errors;
        } else {
          setPasswordMatch("");
          return errors;
        }
      }}
      onSubmit={(values) => {
        changePassword({ ...values }).unwrap().then(res => {
          if (res.success) {
            toast({
              title: "Password changed successfully",
              status: "success",
              duration: 5000,
            });
            navigate("/");
          } else {
            toast({
              title: (res as any).message || "Something went wrong",
              status: "error",
              duration: 5000,
            });
          }
        }).catch(error => {
          console.log('err: ', error);
          toast({
            title: (error.data.error as any).message,
            status: "error",
            duration: 5000,
          });
        })
      }}
    >
      <Form>
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading color="teal" fontSize={'4xl'}>Change Your Password</Heading>
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
                <InputControl
                  isRequired
                  name="currentPassword"
                  label="Current Password"
                  color="teal"
                  inputProps={{
                    placeholder: "Enter Current Password...",
                    type: "password",
                  }}
                />

                <InputControl
                  isRequired
                  name="newPassword"
                  label="New Password"
                  color="teal"
                  inputProps={{
                    placeholder: "Enter New Password...",
                    type: "password",
                  }}
                />

                <InputControl
                  isRequired
                  name="confirmNewPassword"
                  label="Confirm New Password"
                  color="teal"
                  inputProps={{
                    placeholder: "Enter New Password again...",
                    type: "password",
                  }}
                />
                <Text color="red.500" fontSize="small">{passwordMatch}</Text>

                <Stack spacing={10}>
                  <SubmitButton _hover={{
                    bg: 'blue.500',
                  }} isLoading={isLoading}>Change Password</SubmitButton>
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>
      </Form>
    </Formik>
  );
};

export default ChangePassword;
